/**
 * CUSTOM
 * This code has been developed for this solution.
 */
import {
  InvitationCreateData,
  InvitationQueryData,
} from "../../core/models/Invitation";
import NetworkServiceFactory from "../../core/services/network/NetworkService";
import { DEFAULT_QUERY_DATA } from "../../core/services/network/NetworkTypes";
import { useInvitationsContext } from "./InvitationsContext";

const useInvitationsActions = () => {
  const {
    setInvitationsResponseData,
    setInvitationsLoading,
    setSelectedInvitation,
    setInvitationsError,
    invitationsResponseData,
  } = useInvitationsContext();

  const dispatchGetInvitations = async (
    query: InvitationQueryData = DEFAULT_QUERY_DATA()
  ) => {
    const networkService = NetworkServiceFactory.shared;
    try {
      const data = await networkService.getInvitations(query);
      setInvitationsResponseData(data);
      setInvitationsError(undefined);
      return data;
    } catch (e: any) {
      setInvitationsError(e);
    } finally {
      setInvitationsLoading(false);
    }
  };

  const dispatchGetInvitation = (InvitationId: string) => {
    const networkService = NetworkServiceFactory.shared;
    networkService
      .getInvitation(InvitationId)
      .then((invitation) => {
        setSelectedInvitation(invitation);
        setInvitationsError(undefined);
      })
      .catch((e) => {
        setInvitationsError(e);
      });
  };

  const dispatchCreateInvitation = (query: InvitationCreateData) => {
    const asyncCall = async () => {
      try {
        const data = await NetworkServiceFactory.shared.postInvitation(query);
        try {
          if (invitationsResponseData) {
            const data = await NetworkServiceFactory.shared.getInvitations(
              invitationsResponseData
            );
            setInvitationsResponseData(data);
          }
        } catch (e) {
          // Pass
        }
        setSelectedInvitation(data);
        setInvitationsError(undefined);
      } catch (e: any) {
        setInvitationsError(e);
      }
    };
    asyncCall().catch();
  };

  const dispatchCleanInvitationsContext = () => {
    setInvitationsResponseData(undefined);
    setInvitationsError();
    setSelectedInvitation();
  };

  return {
    dispatchGetInvitations,
    dispatchGetInvitation,
    dispatchCleanInvitationsContext,
    dispatchCreateInvitation,
  };
};

export { useInvitationsActions };
